const GET_LOGICMONITOR_MONITORABLE_ASSETS = `
  query LogicmonitorMonitorableAssets {
    logicmonitorMonitorableAssetsTable {
      id
      assetName
      clientName
      status
      logicmonitorMonitorableAssets {
        id
        logicmonitorDeviceId
        alertingEnabled
        deletedAt
        removedFromMonitoring
        credentialKeySuffix
        logicmonitorMonitoringType {
          monitoringType
        }
      }
    }
  }
`

const REMOVE_FROM_LOGICMONITOR = `
  mutation RemoveLogicmonitorMonitorableAssetFromLogicmonitor($id: ID!) {
    removeLogicmonitorMonitorableAssetFromLogicmonitor(input: { id: $id }){
      errors
    }
  }
`

const TOGGLE_ALERTING_ENABLED = `
  mutation ToggleAlertingEnabled($id: ID!) {
    toggleAlertingEnabled(input: { id: $id }){
      errors
      logicmonitorMonitorableAsset {
        alertingEnabled
      }
    }
  }
`

export {
  GET_LOGICMONITOR_MONITORABLE_ASSETS,
  REMOVE_FROM_LOGICMONITOR,
  TOGGLE_ALERTING_ENABLED
}
